import { atom } from 'recoil';
import { TaxType } from '~/types';

const taxType = atom<TaxType>({ key: 'taxType', default: TaxType.PERSONAL });

export default taxType;
